import {ReactElement, ReactNode} from 'react';
import './LayoutCard.scss';
import {categorizeReactNode, ReactNodeCategory} from "../util/type-helpers";

type LayoutCardProps = {
    className?: string,
    children?: {
        header?: ReactNode,
        content?: ReactNode,
        footer?: ReactNode
    }
}

function renderCardHeader(header: ReactNode): ReactNode {
    const headerNodeCategory: ReactNodeCategory = categorizeReactNode(header);
    switch (headerNodeCategory) {
        case ReactNodeCategory.NONE:
            return <></>;
        case ReactNodeCategory.PRIMITIVE_VALUE:
            return <div className="layout-card-text-header layout-card-header-text"><span>{header}</span></div>
        default:
            return header; // If JSX was passed, allowing the user to render it as is
    }
}

export default function LayoutCard(props: LayoutCardProps): ReactElement {

    return (
        <div className={'layout-card ' + (props.className || '')}>
            {renderCardHeader(props?.children?.header)}
            <div className="layout-card-content-area">{props?.children?.content}</div>
            <div>{props?.children?.footer}</div>
        </div>
    );
}